import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  useTheme,
} from '@mui/material'

function Bookmark({ text, open, icon, action, isActive }) {
  const theme = useTheme()

  return (
    <ListItem
      key={text}
      disablePadding
      sx={{ display: 'block' }}
      onClick={action}
    >
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
          margin: '4px 12px',
          borderRadius: 2,
          backgroundColor: isActive ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)') : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)') : '',
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : 'auto',
            justifyContent: 'center',
            color: isActive ? 'primary.main' : 'inherit',
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText 
          primary={text} 
          sx={{ 
            opacity: open ? 1 : 0, 
            color: isActive ? 'primary.main' : 'inherit',
            '& .MuiTypography-root': {
              fontWeight: isActive ? 600 : 400
            }
          }} 
        />
      </ListItemButton>
    </ListItem>
  )
}

export default Bookmark
